export function flattenCategories(rows) {
  if (!Array.isArray(rows)) return []
  const out = []
  rows.forEach(group => {
    if (Array.isArray(group)) {
      group.forEach(item => { if (item) out.push(item) })
    } else if (group) {
      out.push(group)
    }
  })
  return out
}

const OSS_PREFIX = "https://oss.zhengjingkeji.xin"
const DEFAULT_API_ORIGIN = "https://www.zhengjingkeji.xin"

function apiFileOrigin() {
  const fromEnv = String(
    process.env.VUE_APP_FILE_ORIGIN ||
    process.env.VUE_APP_API_BASE ||
    process.env.VUE_APP_DEV_PROXY ||
    ""
  ).trim()
  if (/^https?:\/\//i.test(fromEnv)) {
    return fromEnv.replace(/\/+$/, "")
  }
  return DEFAULT_API_ORIGIN
}

function joinOrigin(origin, path) {
  const base = String(origin || "").replace(/\/+$/, "")
  const rest = String(path || "")
  if (!rest) return base
  return rest.charAt(0) === "/" ? base + rest : base + "/" + rest
}

function rewriteOssHost(url) {
  return String(url || "")
    .replace(/^https?:\/\/huiyoubangoss\.oss-cn-hangzhou\.aliyuncs\.com/i, OSS_PREFIX)
    .replace(/^https?:\/\/bwtc-pic-2026\.oss-cn-beijing\.aliyuncs\.com/i, OSS_PREFIX)
}

function normalizeMediaPath(path) {
  let raw = String(path || "").trim()
  if (!raw) return ""
  // 后台把 OSS 路径存成 //file/...，不能当成 //domain 协议相对地址
  if (raw.indexOf("//file/") === 0 || raw.indexOf("//profile/") === 0) {
    raw = raw.slice(1)
  }
  return raw
}

function isLocalHostUrl(url) {
  return /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/i.test(String(url || ""))
}

function isProfilePath(raw) {
  return /(?:^|\/)profile\//i.test(String(raw || ""))
}

function toProfileUrl(raw) {
  let path = String(raw || "").replace(/^https?:\/\/[^/]+/i, "")
  path = path.replace(/^\/dev-api/, "").replace(/^\/prod-api/, "")
  const idx = path.indexOf("profile/")
  const profilePath = (idx >= 0 ? path.slice(idx) : path).replace(/^\/?profile\//, "/profile/")
  return joinOrigin(apiFileOrigin(), "/manage" + profilePath)
}

function toOssUrl(raw) {
  const path = String(raw || "")
  if (!path) return ""
  return path.charAt(0) === "/" ? OSS_PREFIX + path : OSS_PREFIX + "/" + path
}

export function iconUrl(icon) {
  if (!icon) return ""
  let raw = rewriteOssHost(normalizeMediaPath(icon))
  if (!raw) return ""
  if (isLocalHostUrl(raw) && isProfilePath(raw)) return toProfileUrl(raw)
  if (/^https?:/.test(raw)) return raw
  if (raw.indexOf("//") === 0) return "https:" + raw
  raw = raw.replace(/^\/dev-api/, "").replace(/^\/prod-api/, "")
  if (isProfilePath(raw)) return toProfileUrl(raw)
  return toOssUrl(raw)
}

export function adverUrl(path) {
  if (!path) return ""
  let raw = normalizeMediaPath(String(path).replace(/^["']|["']$/g, ""))
  if (!raw || raw === "null" || raw === "undefined") return ""
  if ((raw.charAt(0) === "[" && raw.charAt(raw.length - 1) === "]") || (raw.charAt(0) === "{" && raw.charAt(raw.length - 1) === "}")) {
    try {
      const parsed = JSON.parse(raw)
      if (Array.isArray(parsed) && parsed[0]) raw = String(parsed[0] && (parsed[0].url || parsed[0]) || "")
      else if (parsed && typeof parsed === "object") raw = String(parsed.pcPictureUrl || parsed.url || parsed.pictureUrl || "")
    } catch (e) {
      raw = raw.replace(/"/g, "").replace("[", "").replace("]", "").split(",")[0]
    }
    raw = normalizeMediaPath(raw)
    if (!raw) return ""
  }
  if (raw.indexOf(",") !== -1 && raw.indexOf("http") !== 0) {
    raw = raw.split(",")[0].trim()
  }
  return fileUrl(raw)
}

export function fileUrl(path) {
  if (!path) return ""
  let raw = rewriteOssHost(normalizeMediaPath(String(path).replace(/^["']|["']$/g, "")))
  if (!raw || raw === "null" || raw === "undefined") return ""
  if (isLocalHostUrl(raw) && isProfilePath(raw)) return toProfileUrl(raw)
  if (/^https?:/.test(raw)) return raw
  if (raw.indexOf("//") === 0) return "https:" + raw
  raw = raw.replace(/^\/dev-api/, "").replace(/^\/prod-api/, "")
  if (raw.indexOf("/static") === 0 || raw.indexOf("data:") === 0) return raw
  if (isProfilePath(raw)) return toProfileUrl(raw)
  if (raw.indexOf("/file/") === 0 || raw.indexOf("file/") === 0) {
    return toOssUrl(raw.charAt(0) === "/" ? raw : "/" + raw)
  }
  return iconUrl(raw)
}

export function categoryGroups(rows) {
  const raw = Array.isArray(rows) ? rows : []
  let groups = []
  if (raw.length && raw.every(item => Array.isArray(item))) {
    groups = raw.map(group =>
      group
        .filter(item => item && item.name && item.name !== "更多")
        .map(item => ({ ...item, icon: iconUrl(item.icon) }))
        .slice(0, 10)
    )
  } else {
    const flat = flattenCategories(raw)
      .filter(item => item && item.name && item.name !== "更多")
      .map(item => ({ ...item, icon: iconUrl(item.icon) }))
    for (let i = 0; i < 30; i += 10) groups.push(flat.slice(i, i + 10))
  }
  while (groups.length < 3) groups.push([])
  groups[2] = groups[2].slice(0, 9)
  return groups.slice(0, 3)
}

export function categoryGridRows(rows) {
  const flat = flattenCategories(rows)
    .filter(item => item && item.name && item.name !== "更多")
    .map(item => ({ ...item, icon: iconUrl(item.icon) }))
  const shown = flat.slice(0, 29)
  const grid = []
  for (let i = 0; i < shown.length; i += 10) {
    grid.push(shown.slice(i, i + 10))
  }
  while (grid.length < 3) grid.push([])
  if (grid[2].length > 9) grid[2] = grid[2].slice(0, 9)
  return grid.slice(0, 3)
}

export function categoryFormConfigs(item) {
  if (!item) return []
  const list = item.formConfigList || item.sysFormConfigList || []
  return Array.isArray(list) ? list : []
}

export function categoryQuery(item) {
  const formConfig = categoryFormConfigs(item)[0] || {}
  return {
    name: (item && item.name) || "",
    sysFormId: formConfig.serviceId || "",
    configId: (item && item.configId) || formConfig.id || "",
    type: (item && item.type) || "",
    displayStatus: (item && (item.displayStatus || item.display_status)) || ""
  }
}

export function goCategory(router, item) {
  const name = (item && item.name) || ""
  if (name === "微信群" || name === "公众号") {
    return router.push({ name: "WechatGroup", query: { name } })
  }
  if (name === "新闻资讯") {
    return router.push({ name: "News" })
  }
  if (name === "领红包") {
    return router.push({ name: "Redpacket" })
  }
  if (name === "电话本") {
    return router.push({ name: "Phonebook" })
  }
  router.push({ name: "Category", query: categoryQuery(item) })
}

export function goDetail(router, item, extra = {}) {
  if (!item || !item.businessId) return
  const pcAd = item.pcAdvertisingPictureUrl || extra.pcAdvertisingPictureUrl || ""
  if (pcAd) {
    try {
      sessionStorage.setItem("detailPcAd:" + item.businessId, pcAd)
    } catch (e) {
      // ignore
    }
  }
  router.push({
    name: "Detail",
    params: { id: item.businessId },
    query: {
      serviceId: item.serviceId || extra.serviceId || "",
      sysFormId: item.formId || item.sysFormId || extra.sysFormId || "",
      siteId: item.siteId || extra.siteId || "",
      type: item.rowType || item.type || extra.type || "",
      hongbao: extra.hongbao || "",
      luckyMoneyId: extra.luckyMoneyId || item.luckyMoneyId || "",
      title: extra.title || item.serviceName || ""
    }
  })
}

export function goLogin(router, route) {
  router.push({
    name: "Login",
    query: { redirect: (route && route.fullPath) || "/home" }
  })
}

export function requireLogin(vm) {
  if (vm.$store.getters.isLoggedIn) return true
  vm.$message.warning("请先登录")
  goLogin(vm.$router, vm.$route)
  return false
}

export function findCategoryByName(rows, name) {
  return flattenCategories(rows).find(item => item && item.name === name) || null
}
